<template>
  <el-dialog :visible.sync="dialogVisible" :width="type === 1 ? '1150px' : '650px'" :show-close="false"
             :lock-scroll="false">
    <div slot="title" class="img_dialog_title">
      <div class="img_category" :style="type === 2 ? 'visibility: hidden' : ''">
        <div class="category_item" :class="currentType === '全部图片' ? 'is_active' : ''"
             @click="changeImgType('全部图片')">
          全部图片({{ imgList ? imgList.length : 0 }})
        </div>
        <div class="category_item" :class="currentType === item ? 'is_active' : ''" v-for="(item, index) in imgTypes"
             :key="index" @click="changeImgType(item)">
          {{ item }}({{ getImgCount(item) }})
        </div>
      </div>

      <i class="el-icon-close" style="font-size: 24px;cursor:pointer;" @click="closeDialog"/>
    </div>
    <div class="img_content" v-if="type === 1">
      <div class="big_img_content" @wheel.stop="handleWheel">
        <img :src="bigImgSrc.url" class="big_img" ref="bigImg"
             :style="{transform: `rotate(${imgRotation}deg)`, scale: imgScale}"/>
        <div class="arrow_left" @click="lastImg">
          <i class="el-icon-arrow-left"/>
        </div>
        <div class="arrow_right" @click="nextImg">
          <i class="el-icon-arrow-right"/>
        </div>
        <div class="tool_box">
          <i class="el-icon-zoom-in" @click="zoomImg(0.3)"></i>
          <i class="el-icon-zoom-out" @click="zoomImg(-0.3)"></i>
          <i class="el-icon-refresh-left" @click="rotateImg(-90)"></i>
          <i class="el-icon-refresh-right" @click="rotateImg(90)"></i>
        </div>
        <span class="img_name" v-show="getImgName">{{ getImgName }}</span>
      </div>
      <div class="small_img_content">
        <div v-for="(item, index) in filterImgList" :key="index">
          <img :src="item.imageUrl" class="small_img"
               :class="bigImgSrc.key === item.key ? `is_active img_${index}` : `img_${index}`"
               @click="clickImg(item)"/>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="room_img_box">
        <div class="big_img_content">
          <div :class="bigImgSrc.url ? '' : 'image_box'">
            <img :src="bigImgSrc.url ? bigImgSrc.url : require('@/assets/newImage/noSwiperImg1.png')" class="big_img"
                 ref="bigImg"
                 :style="{transform: `rotate(${imgRotation}deg)`, scale: imgScale}"
                 :class="bigImgSrc.url ? '' : 'noImg'"/>
          </div>
          <div class="arrow_left" @click="lastImg" v-if="imgList.length > 1">
            <i class="el-icon-arrow-left"/>
          </div>
          <div class="arrow_right" @click="nextImg" v-if="imgList.length > 1">
            <i class="el-icon-arrow-right"/>
          </div>
        </div>
        <div class="small_img_content room">
          <div v-for="(item, index) in filterImgList" :key="index">
            <img :src="item.imageUrl" class="small_img"
                 :class="bigImgSrc.key === item.key ? `is_active img_${index}` : `img_${index}`"
                 @click="clickImg(item)"/>
          </div>
        </div>
      </div>
      <div>
        <div style="color: #1f2937;font-size: 16px;font-weight: 600;margin: 15px 0;width: 425px">
          {{ $commonUtil.getCnStr(room.nameCn, room.nameEn) }}
          <span v-if="room.regionId === 2" style="font-weight: normal;font-size: 12px">{{ room.nameEn }}</span>
        </div>
        <div class="desc_box">
          <div class="desc_item" v-if="room.bedInfo">
            <i class="iconfont icon-a-qietu1" />
            床型: <span style="color: #202020">{{ room.bedInfo }}</span>
          </div>
          <div class="desc_item" v-if="room.floor">
            <i class="iconfont icon-louceng" />
            楼层: <span style="color: #202020">{{ room.floor }}</span>
          </div>
          <div class="desc_item" v-if="room.area">
            <i class="iconfont icon-a-qietu2" />
            面积: <span style="color: #202020">{{ room.area }}m²</span>
          </div>
          <div class="desc_item" v-if="room.windowType === 0 || room.windowType">
            <i class="iconfont icon-a-qietu5" />
            窗型: <span style="color: #202020">{{ windowTypeMap[room.windowType] }}</span>
          </div>
          <div class="desc_item" v-if="room.maxOccupancy">
            <i class="iconfont icon-a-qietu3" />
            入住人数: <span style="color: #202020">最多入住{{ room.maxOccupancy }}人</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'HotelImg',
  data () {
    return {
      imgList: [],
      dialogVisible: false,
      bigImgSrc: {url: '', key: ''},
      imgRotation: 0,
      imgScale: 1,
      type: '',
      imgTypes: [],
      currentType: '全部图片',
      room: {},
      windowTypeMap: {
        0: '无窗',
        1: '有窗',
        2: '部分有窗',
        3: '暗窗',
        5: '封闭窗',
        4: '窗型未知'
      }
    }
  },
  computed: {
    getImgName () {
      let currImg = this.imgList.find(item => item.key === this.bigImgSrc.key)
      if (currImg && currImg.roomNameCn) {
        return currImg.roomNameCn
      }
      return ''
    },
    filterImgList () {
      if (this.currentType === '全部图片') return this.imgList
      return this.imgList.filter(item => item.imageType === this.currentType)
    }
  },
  methods: {
    init (img, index, type, room) {
      if (type === 2) {
        this.room = room
      }
      this.type = type
      if (!img.length && index < 0 && type === 2) {
        this.imgList = []
        this.bigImgSrc.url = ''
        this.dialogVisible = true
        return
      }
      this.initImg()
      this.imgList = img
      this.bigImgSrc.url = this.imgList[index].imageUrl
      this.bigImgSrc.key = this.imgList[index].key
      this.currentType = '全部图片'
      this.imgTypes = new Set(this.imgList.map(item => item.imageType))
      this.dialogVisible = true
    },
    changeImgType (type) {
      this.currentType = type
      this.bigImgSrc.url = this.filterImgList[0].imageUrl
      this.bigImgSrc.key = this.filterImgList[0].key
      this.initImg()
      this.toPoint('.img_0')
    },
    getImgCount (type) {
      return this.imgList.reduce((cur, obj) => {
        if (obj.imageType === type) {
          cur++
        }
        return cur
      }, 0)
    },
    clickImg (imgSrc) {
      this.bigImgSrc.url = imgSrc.imageUrl
      this.bigImgSrc.key = imgSrc.key
    },
    initImg () {
      this.imgScale = 1
      this.imgRotation = 0
    },
    lastImg () {
      this.initImg()
      let index = this.filterImgList.findIndex(item => this.bigImgSrc.key === item.key)
      if (index < 0) return
      if (index === 0) {
        index = this.filterImgList.length - 1
      } else {
        index = index - 1
      }
      this.bigImgSrc.url = this.filterImgList[index].imageUrl
      this.bigImgSrc.key = this.filterImgList[index].key
      this.toPoint(`.img_${index}`)
    },
    nextImg () {
      this.initImg()
      let index = this.filterImgList.findIndex(item => this.bigImgSrc.key === item.key)
      if (index < 0) return
      if (index === this.filterImgList.length - 1) {
        index = 0
      } else {
        index = index + 1
      }
      this.bigImgSrc.url = this.filterImgList[index].imageUrl
      this.bigImgSrc.key = this.filterImgList[index].key
      this.toPoint(`.img_${index}`)
    },
    toPoint (className) {
      this.$el.querySelector(className).scrollIntoView({block: 'start', behavior: 'smooth'})
    },
    closeDialog () {
      this.dialogVisible = false
    },
    rotateImg (angle) {
      this.imgRotation += angle
    },
    zoomImg (scale) {
      if (this.imgScale + scale < 0) return
      this.imgScale += scale
    },
    handleWheel (event) {
      event.preventDefault()
      let scale = event.deltaY > 0 ? -0.3 : 0.3
      this.zoomImg(scale)
    }
  }
}
</script>

<style scoped lang="less">
.img_dialog_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 38px;

  .img_category {
    display: flex;

    .category_item {
      height: 20px;
      font-size: 16px;
      padding: 0 25px;
      cursor: pointer;
      user-select: none;

      &.is_active {
        color: #1e50f1;
        font-weight: bolder;
      }

      &:first-child {
        padding-left: 0;
      }

      &:not(:last-child) {
        border-right: 2px solid #d7d7d7;
      }
    }
  }
}

.img_content {
  height: 550px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 330px;
  grid-column-gap: 25px;

  .big_img_content {
    border: 1px solid #d7d7d7;
    overflow: hidden;
    position: relative;

    .arrow_left {
      left: 1%;

      &:hover {
        color: #4b4d4d;
      }
    }

    .arrow_right {
      right: 1%;

      & /deep/ .el-icon-arrow-right {
        color: #fff;

        &:hover {
          color: #4b4d4d;
        }
      }
    }

    .arrow_right, .arrow_left {
      top: 50%;
      text-align: center;
      background-color: rgba(102, 103, 107, .6);
      border-radius: 50%;
      position: absolute;
      font-size: 20px;
      padding: 5px;
      cursor: pointer;
      color: #fff;
    }

    .tool_box {
      display: flex;
      column-gap: 15px;
      position: absolute;
      bottom: 0;
      left: calc(50% - 78.5px);
      padding: 5px 16px;
      background-color: rgba(102, 103, 107, .6);
      color: #fff;
      font-size: 20px;
      border-radius: 50px;

      i {
        cursor: pointer;

        &:hover {
          color: #4b4d4d;
        }
      }
    }

    .img_name {
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .4);
      padding: 10px 18px;
      color: #fff;
    }
  }

  .big_img {
    width: 100%;
    height: 550px;
    object-fit: contain;
    transition: all .1s ease-in-out;
  }

  .small_img_content {
    height: 550px;
    overflow: auto;
    display: grid;
    grid-template-columns: repeat(3, 100px);
    grid-gap: 10px;
    grid-auto-rows: 100px;

    .small_img {
      width: 100%;
      height: 100px;
      object-fit: cover;
      cursor: pointer;

      &.is_active {
        border: 5px solid #148cf5;
      }
    }
  }
}

.room_img_box {
  height: 285px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 130px;
  grid-column-gap: 25px;
  margin-bottom: 35px;

  .big_img_content {
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    height: 285px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .arrow_left {
      left: 1%;

      &:hover {
        color: #4b4d4d;
      }
    }

    .arrow_right {
      right: 1%;

      & /deep/ .el-icon-arrow-right {
        color: #fff;

        &:hover {
          color: #4b4d4d;
        }
      }
    }

    .arrow_right, .arrow_left {
      top: 50%;
      text-align: center;
      background-color: rgba(102, 103, 107, .6);
      border-radius: 50%;
      position: absolute;
      font-size: 20px;
      padding: 5px;
      cursor: pointer;
      color: #fff;
    }

    .image_box {
      position: relative;
      overflow: hidden;

      .noImg {
        filter: blur(3px);
        transform: scale(1.03);
      }

      &::before {
        content: '暂无图片';
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 1px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
      }
    }

    .big_img {
      width: 100%;
      height: 285px;
      transition: all .1s ease-in-out;
      border-radius: 8px;

      img {
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }

  .small_img_content {
    height: 285px;
    overflow: auto;
    padding-right: 5px;

    .small_img {
      width: 100%;
      height: 70px;
      object-fit: cover;
      cursor: pointer;
      margin-bottom: 15px;
      border-radius: 8px;

      img {
        border-radius: 8px;
      }

      &.is_active {
        border: 5px solid #148cf5;
      }
    }
  }
}

.desc_box {
  display: flex;
  flex-wrap: wrap;
  row-gap: 15px;
  justify-content: space-between;

  .desc_item {
    width: 50%;
    color: #5e6673;

    i {
      font-size: 15px;
      color: #3b82f6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/HotelImg.vue